'use client'

import type { ApartmentGalleryTourItem } from '@/lib/apartments/apartmentGallery'
import { cn } from '@/utilities/ui'

type RoomGalleryVideoPanelProps = {
  className?: string
  isActive: boolean
  objectFit?: 'cover' | 'contain'
  tour: ApartmentGalleryTourItem
}

export function RoomGalleryVideoPanel({
  className,
  isActive,
  objectFit = 'cover',
  tour,
}: RoomGalleryVideoPanelProps) {
  const fitClassName = objectFit === 'contain' ? 'object-contain' : 'object-cover'

  return (
    <div
      className={cn('relative size-full min-h-0 bg-black/10', className)}
      data-gallery-interactive=""
    >
      {isActive ? (
        <iframe
          allow="accelerometer; fullscreen; gyroscope; vr; xr-spatial-tracking"
          allowFullScreen
          className={cn('block size-full border-0 bg-black object-center', fitClassName)}
          src={tour.embedUrl}
          title={tour.title}
        />
      ) : (
        <div aria-hidden className="size-full bg-black/10" />
      )}
    </div>
  )
}
